import { isMobile } from "react-device-detect";
import styled from "styled-components";

export const RodapeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 20px;
  align-items: flex-start;
  padding: ${isMobile ? "10px" : "0px"};
`;

export const CompraSegura = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self: center;
`;

export const HelpContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const NeedHelp = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HelpText = styled.p`
  font-size: 11.31pt;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: #9c9e9f;
`;
export const HelpLink = styled.a`
  color: #39a9dc;
  font-size: 11.31pt;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
`;

export const IuguProcess = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;
